import axios from '@dap/shared-utils/http.js';

const defaultConfig = {
    headers: { 'Content-Type': 'application/json' },
};
const BASE_URL = '/dapper/api/script_library';

export default {
    // 字典
    getDict () {
        return axios.get(`${BASE_URL}/data_dict`);
    },
    // 内容标签的四个列表
    getTagLists (params) {
        return axios.get('/dapper/api/script_library/content_tag_list', {
            params,
        });
    },
    // 脚本列表
    getList (params) {
        return axios.get(BASE_URL, { params });
    },
    // 新脚本列表
    getList_new (params) {
        return axios.get('/dapper/api/material_script/script/filter', {
            params,
        });
    },

    // 脚本详情
    getDetail (id) {
        return axios.get(`${BASE_URL}/detail?id=${id}`);
    },
    // 新建/编辑
    editScript (params) {
        if (params.id) {
            return axios.put(BASE_URL, { ...params, is_draft: 0 }, defaultConfig);
        }
        return axios.post(BASE_URL, { ...params, is_draft: 0 }, defaultConfig);
    },
    // 保存草稿
    editDraft (params) {
        if (params.id) {
            return axios.put(BASE_URL, { ...params, is_draft: 1 }, defaultConfig);
        }
        return axios.post(BASE_URL, { ...params, is_draft: 1 }, defaultConfig);
    },
    // 删除
    deleteScript (params) {
        return axios.delete(BASE_URL, { params });
    },
    // 下载脚本
    downloadScript (params) {
        return axios.get(`${BASE_URL}/download`, { params });
    },
    // 上传附件
    upload (params) {
        return axios.post(`${BASE_URL}/upload`, params, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    // 脚本评审
    audit (params) {
        if (params.script_review_id) {
            return axios.put(`${BASE_URL}/review`, params, defaultConfig);
        }
        return axios.post(`${BASE_URL}/review`, params, defaultConfig);
    },
    // 创意方向类型
    getCreativeDirectionDataType (params = {}) {
        return axios.get('/dapper/api/material_script/data_type', { params });
    },
};
